<template>
  <button
    :class="[
      isSelected
        ? ' -mt-px border-t-2 border-primary pt-2.5 sm:pt-3 px-4 inline-flex items-center text-sm leading-5 font-normal text-primary focus:outline-none focus:text-primary focus:border-primary transition ease-in-out duration-150'
        : ' -mt-px border-t-2 border-transparent pt-2.5 sm:pt-3 px-4 inline-flex items-center text-sm leading-5 font-normal text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-400 transition ease-in-out duration-150',
    ]"
    @click="$emit('click')"
  >
    <slot />
  </button>
</template>

<script>
export default {
  emits: ["click"],
  props: {
    isSelected: Boolean,
  },
};
</script>
